/**
 * ReportThemePanel (Story 37.2 framework — finalized in Story 37.6)
 *
 * The `report-theme` category's floating-panel body. `report-theme` is a
 * first-class registry entry that floats + pushes the canvas like every other
 * sidebar icon, but it is a PURE INFORMATIONAL STUB — per ADR-RE-6 ("framework
 * yes, schema no") there is NO `layoutJson.theme` field, no migration, and
 * `report-theme` is NOT a widget type (it adds nothing to the canvas, so there
 * is no draft, no Add button, and it never consumes `onWidgetAdd`).
 *
 * Story 37.6 finalized the stub: the body now follows the sibling
 * `*CategoryPanel.tsx` design-system convention (`flex h-full flex-col p-3`
 * shell, `mb-3 flex items-center gap-2` header with a lucide icon at
 * `size={18} text-muted-foreground` + `text-[13px] font-semibold` heading) and
 * presents a polished "coming soon" empty-state (icon + headline + supporting
 * description, no dead CTA). Real theming controls remain DEFERRED to a future
 * epic per ADR-RE-6 — this panel ships the coming-soon treatment only.
 */

import { Palette } from "lucide-react";

export function ReportThemePanel() {
  return (
    <div className="flex h-full flex-col p-3" data-testid="report-theme-panel">
      <div className="mb-3 flex items-center gap-2">
        <Palette
          size={18}
          className="text-muted-foreground"
          aria-hidden="true"
          data-testid="report-theme-header-icon"
        />
        <h3 className="text-[13px] font-semibold text-foreground">Report Theme</h3>
      </div>

      <div className="flex flex-1 flex-col items-center justify-center gap-2 px-4 text-center">
        <Palette size={32} className="text-muted-foreground" aria-hidden="true" />
        <p className="text-[13px] font-medium text-foreground">Theming — coming soon</p>
        <p className="text-[11px] text-muted-foreground">
          Brand colors, fonts, and report styling will live here.
        </p>
      </div>
    </div>
  );
}
